import { $ } from '@/libs/jquery/index'
import { moment } from '@/libs/moment'

$.validator.addMethod('cardexpiredate', function(value: string, element: HTMLElement): boolean {
  const [ month, year ] = value.split('/').map((x) => parseInt(x, 10))

  const isMonthValid: boolean = (month > 1 && month < 13)

  const isYearValid: boolean = (year && year > 1000 &&
      year > moment().year())

  return this.optional(element) || (isMonthValid && isYearValid)
}, 'Некорректный формат номера карты')
